export const CATEGORY_THEME_MAP = {
    Member: "indigo",
    Sympathizer: "purple",
    Donor: "cyan",
    Volunteer: "orange",
    Other: "green",
};
export function getCategoryBadgeTheme(category) {
    return CATEGORY_THEME_MAP[category] ?? "neutral";
}
/**
 * Aliases mapping a localized label (FR/EN, accent- and case-insensitive once normalized) to the
 * canonical category, for free-form values that aren't guaranteed to be the enum — e.g. OPHUB
 * segment tags ("Donateur", "Benevole") rendered as category badges in the audience popup.
 */
const CATEGORY_LABEL_ALIASES = {
    member: "Member",
    membre: "Member",
    sympathizer: "Sympathizer",
    sympathisant: "Sympathizer",
    donor: "Donor",
    donateur: "Donor",
    volunteer: "Volunteer",
    benevole: "Volunteer",
    other: "Other",
    autre: "Other",
};
/**
 * Resolve a badge theme from a free-form category value or label (enum member or FR/EN label),
 * reusing {@link CATEGORY_THEME_MAP} as the single source of truth for the colors. Returns
 * {@link fallback} (default "neutral") when the value matches no known category.
 */
export function getCategoryThemeFromLabel(value, fallback = "neutral") {
    if (CATEGORY_THEME_MAP[value]) {
        return CATEGORY_THEME_MAP[value];
    }
    const normalized = value
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase()
        .trim();
    const category = CATEGORY_LABEL_ALIASES[normalized];
    return category ? CATEGORY_THEME_MAP[category] : fallback;
}
